// extracted by mini-css-extract-plugin
export default {"container":"Bio_container__DgIy5","menu":"Bio_menu__52DdS","content":"Bio_content__i-Pcl"};